<template>
  <div class="diBeiH5" ref="diBeiH5">
    <div class="diBei">
      <div class="text">
        <div class="t1">订呗智能订货平台</div>
        <div class="t2">
          订呗订货平台是数字神经系统，以订单处理为核心，帮助企业快速构建全渠道营销订货平台。企业通过平台展示商品、引流客户，提升部门效率，而帮助企业降本增效、提升利润、加速资金流转，推动销售模式变革让生意更简单。
        </div>
      </div>
      <div class="btn" @click="goto">联系我们</div>
    </div>
    <div class="diBei-ji">
      <div class="box-img">
        <img src="~@/assets/diBei-img.png" class="img" alt="" />
      </div>
    </div>
    <div class="multi-terminal">
      <div class="text">
        <div class="t1">多终端管理，流程优化</div>
        <div class="t2">
          传统管理软件，大多都存在操作难度偏大，流程复杂的问题。订呗智能订货平台以便捷为前提，对主要功能流程进行针对性的优化，让商家快速上手。
        </div>
      </div>
      <div class="img-box">
        <img src="~@/assets/multi-terminal.png" class="img" alt="" />
      </div>
    </div>
    <div class="characteristic">
      <div class="text">订呗平台特性</div>
      <div class="te">特</div>
      <div class="box box1">
        <div class="title-box">
          <div class="title">专业化</div>
          <img src="~@/assets/specialized.png" class="img" alt="" />
        </div>
        <div class="txt">专业商用开单、操作精简、使用便捷</div>
      </div>
      <div class="box box2">
        <div class="title-box">
          <div class="title">数据安全</div>
          <img src="~@/assets/Safety.png" class="img" alt="" />
        </div>
        <div class="txt">权威认证金牌服务商阿里云</div>
      </div>
      <div class="box box3">
        <div class="title-box">
          <div class="title">高效管理</div>
          <img src="~@/assets/manageH5.png" class="img" alt="" />
        </div>
        <div class="txt">管理规范、权限层级明了，保护隐私</div>
      </div>
      <div class="box box4">
        <div class="title-box">
          <div class="title">资源生态化</div>
          <img src="~@/assets/Ecological.png" class="img" alt="" />
        </div>
        <div class="txt">上下游互通，资源互补，告别传统烦恼</div>
      </div>
    </div>
    <div class="characteristic1">
      <div class="text">订呗平台特性</div>
      <img src="~@/assets/youshi.png" class="img" alt="" />
    </div>

    <div class="serve">
      <div class="text">我们的服务体系</div>
      <div class="serve-box">
        <div class="serve-item" v-for="item of serveList" :key="item.title">
          <div class="img-box">
            <img :src="item.url" class="img" alt="" />
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="txt">
            {{ item.txt }}
          </div>
        </div>
      </div>
    </div>
    <div class="insight">
      <div class="text">
        <div class="t1">智能分析系统</div>
        <div class="t2">数据实时可视化，让上级管理更高效</div>
      </div>
      <div class="insight-liet">
        <div class="insight-item" v-for="item of insightList" :key="item.title">
          <div class="img-box">
            <img class="img" :src="item.url" alt="" />
          </div>
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serveList: [
        {
          title: "营销工具",
          txt: "精确到计划、单元、关键词、创意每个层级的转化效果监测，不断优化调整。",
          url: require("@/assets/yxgj.png"),
        },
        {
          title: "数据报表",
          txt: "用户画像、商品预警、订单报表、商品报表、业绩报表、毛利报表。",
          url: require("@/assets/sjbb.png"),
        },
        {
          title: "订单管控",
          txt: "订货管理、退货管理、订单维度统计、订单核准",
          url: require("@/assets/ddgk.png"),
        },
        {
          title: "采购库存管理",
          txt: "智能采购、供应链管理、出入库调拨、出入库盘点、汇总核算。",
          url: require("@/assets/cgkcgl.png"),
        },
        {
          title: "资金结算",
          txt: "资金账户、在线支付、往来对账、收支明细、订单收款统计。",
          url: require("@/assets/zjjs.png"),
        },
        {
          title: "运营优化",
          txt: "开放商城、自定义商城、 拉新、分销、客户管理、拜访客户。",
          url: require("@/assets/yyyh.png"),
        },
      ],
      insightList: [
        {
          title: "客流分析",
          url: require("@/assets/klfx.png"),
        },
        {
          title: "客群分析",
          url: require("@/assets/kqfx.png"),
        },
        {
          title: "交易洞察",
          url: require("@/assets/jydc.png"),
        },
        {
          title: "营销效果",
          url: require("@/assets/yxxg.png"),
        },
        {
          title: "服务管理",
          url: require("@/assets/fwgl.png"),
        },
        {
          title: "仓储管理",
          url: require("@/assets/ccgl.png"),
        },
      ],
    };
  },
  activated() {
    this.$refs.diBeiH5.scrollIntoView();
  },
  methods: {
    goto() {
      this.$router.push({
        name: "h5contactus",
      });
    },
  },
};
</script>
<style lang="less" scoped>
.diBeiH5 {
  .diBei {
    width: 750px;
    height: 860px;
    background: url("~@/assets/dbbg.png") no-repeat;
    background-size: 100% 100%;
    padding: 80px 65px;
    .text {
      text-align: center;
      .t1 {
        font-size: 64px;
        line-height: 80px;
        font-weight: 500;
        color: #ffffff;
      }
      .t2 {
        text-align: left;
        margin: 42px 0;
        font-size: 26px;
        line-height: 40px;
        color: #ffffff;
      }
    }
    .btn {
      width: 212px;
      height: 64px;
      color: #005ce6;
      text-align: center;
      margin: 54px auto 0;
      font-size: 30px;
      line-height: 64px;
      background: #ffffff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 6px;
    }
  }
  .diBei-ji {
    width: 750px;
    height: 126px;
    background: #fff;
    position: relative;
    .box-img {
      width: 610px;
      height: 462px;
      position: absolute;
      left: 71px;
      bottom: 0px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .multi-terminal {
    padding: 64px 55px;
    background: #fff;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 58px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        line-height: 40px;
        font-size: 26px;
        color: #51565d;
      }
    }
    .img-box {
      width: 420px;
      height: 336px;
      margin: 60px auto 0;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .characteristic {
    width: 750px;
    height: 1070px;
    background: url("~@/assets/texing.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 64px;
    position: relative;
    .text {
      text-align: center;
      font-weight: 500;
      font-size: 40px;
      line-height: 48px;
      color: #292929;
    }
    .box {
      position: absolute;
      height: 138px;
      background: #ffffff;
      box-shadow: 4px 4px 10px rgba(0, 42, 106, 0.12);
      border-radius: 8px;
      padding: 24px;
      .title-box {
        display: flex;
        align-items: center;
        .title {
          font-weight: 400;
          font-size: 30px;
          line-height: 40px;
          color: #51565d;
          margin-right: 16px;
        }
        .img {
          width: 40px;
          height: 40px;
        }
      }
      .txt {
        font-size: 26px;
        line-height: 34px;
        margin-top: 16px;
        color: #888888;
      }
    }
    .box1 {
      left: 117px;
      top: 174px;
    }
    .box2 {
      padding-right: 77px;
      left: 231px;
      top: 396px;
    }
    .box3 {
      right: 55px;
      bottom: 314px;
    }
    .box4 {
      left: 76px;
      bottom: 92px;
    }
    .te {
      position: relative;
      left: 11px;
      top: 400px;
      font-weight: 500;
      font-size: 92px;
      line-height: 133px;
      color: #ffffff;
    }
  }
  .characteristic1 {
    width: 750px;
    padding: 64px 40px 0;
    .text {
      text-align: center;
      font-weight: 500;
      font-size: 40px;
      line-height: 48px;
      color: #292929;
    }
    .img {
      margin-top: 24px;
      width: 670px;
    }
  }
  .serve {
    padding: 64px 40px 46px;
    width: 750px;
    background: #f8faff;
    .text {
      text-align: center;
      font-weight: 500;
      font-size: 40px;
      line-height: 48px;
      color: #292929;
    }
    .serve-box {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .serve-item {
        padding: 36px 32px 58px;
        width: 319px;
        height: 380px;
        background: #ffffff;
        box-shadow: 0px 6px 20px rgba(68, 93, 127, 0.1);
        border-radius: 8px;
        margin-bottom: 24px;
        .img-box {
          width: 72px;
          height: 72px;
          margin: 0 auto;
          .img {
            width: 72px;
            height: 72px;
          }
        }

        .title {
          font-size: 30px;
          line-height: 38px;
          text-align: center;
          color: #292929;
          margin: 24px 0 16px;
        }
        .txt {
          font-size: 28px;
          line-height: 40px;
          text-align: left;
          color: #888888;
        }
      }
    }
  }
  .insight {
    padding: 64px 32px 80px;
    background: #ffffff;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 24px;
        font-size: 28px;
        color: #51565d;
        line-height: 40px;
      }
    }
    .insight-liet {
      display: flex;
      flex-wrap: wrap;
      margin-top: 50px;
      justify-content: space-between;
      .insight-item {
        width: 212.67px;
        height: 200px;
        background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
        border: 4px solid #ffffff;
        box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
        border-radius: 10px;
        margin-bottom: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img-box {
          width: 80px;
          height: 80px;
          .img {
            width: 80px;
            height: 80px;
          }
        }
        .title {
          margin-top: 16px;
          font-size: 30px;
          line-height: 40px;
          text-align: center;
          color: #51565d;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/diBeiH5.vue